import { GlEmptyState } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import EmptyResult, { TYPES } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/empty_result.vue?vue3';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export { TYPES };
export default {
    name: 'ResourceListsEmptyState',
    components: {
        GlEmptyState,
        EmptyResult
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        search: {
            type: String,
            required: false,
            default: ''
        },
        searchMinimumLength: {
            type: Number,
            required: false,
            default: 0
        },
        type: {
            type: String,
            required: false,
            default: TYPES.search,
            validator: (type)=>Object.values(TYPES).includes(type)
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false,
            default: null
        },
        svgPath: {
            type: String,
            required: true
        },
        searchHint: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        hasSearch () {
            return Boolean(this.search);
        }
    }
};
